import request from 'superagent';

export const fetchAppVersion = () =>
  request.get(`${window.basePath}version.json`);

export const fetchConfiguration = () =>
  request.get(`${window.basePath}private-config.json`).withCredentials();
